import React, { ReactElement } from "react";
import oc from "open-color";
import Counter from "./Counter";

export default function Counters({
  counters,
  shortFormat,
}: {
  counters: React.ReactElement<typeof Counter>[];
  shortFormat: boolean;
}): ReactElement {
  const content: ReactElement[] = [];
  for (let i = 0; i < counters.length; i++) {
    const isLast = i === counters.length - 1;
    content.push(counters[i]);
    if (!isLast) {
      content.push(
        <hr
          key={`hr-${i}`}
          style={{
            height: "1px",
            backgroundColor: oc.gray[5],
            padding: 0,
            margin: "10px 0",
            border: "none",
          }}
        />,
      );
    }
  }

  return (
    <>
      {counters.length ? (
        <div
          className="d-flex flex-column"
          style={{
            padding: shortFormat ? "0" : "10px",
            border: shortFormat ? "" : `2px solid ${oc.gray[5]}`,
            borderRadius: "5px",
            backgroundColor: shortFormat ? "transparent" : oc.gray[0],
            marginTop: "15px",
          }}
        >
          <div>{content}</div>
        </div>
      ) : null}
    </>
  );
}
